import { render } from "./QueryBuilderGroup.vue?vue&type=template&id=dd3bc070"
import script from "./QueryBuilderGroup.vue?vue&type=script&lang=js"
export * from "./QueryBuilderGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__